import { useCallback, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

import { useSinglePageGrid } from "2g-grid";
import { actions as formActions } from "2g-form";
import { dispatchModuleAction } from "2g-utils-redux";

import { DATA } from "b2b/api/paths";
import { ZadostiRowDetail } from "b2b/components/zadosti-row-detail/ZadostiRowDetail";

import useMessages from "b2b/components/zadosti-odbaveni-grid/i18n/useMessages";
import FilterContent from "b2b/components/zadosti-odbaveni-grid/FilterContent";
import {
  getSelectedIdsFromGrid,
  isRowSelectable
} from "b2b/components/zadosti-odbaveni-grid/utils";

import useColumns from "./useColumns";
import useColumnsHandleClick from "./useColumnsHandleClick";
import useZadostiOdbaveniToolbar from "./useZadostiOdbaveniToolbar";

export default function useZadostiOdbaveniGrid() {
  const history = useHistory();
  const dispatch = useDispatch();
  const gridResultRef = useRef();
  const handleActionSuccess = useCallback(() => {
    gridResultRef.current.result.reload();
  }, []);
  const { handleClickAccept, handleClickDecline } =
    useColumnsHandleClick(handleActionSuccess);
  const columns = useColumns({ handleClickAccept, handleClickDecline });
  const messages = useMessages();

  useEffect(() => {
    history.location?.state &&
      dispatchModuleAction(
        dispatch,
        gridResultRef.current.filter.filterFormModuleKey,
        formActions.setValue("zdroj", history.location?.state)
      );
  }, [history.location?.state]);

  gridResultRef.current = useSinglePageGrid({
    filter: {
      asSlideFilter: true,
      content: FilterContent,
      title: messages.pageHeadingFilter()
    },
    moduleKey: "zadostiOdbaveniGrid",
    result: {
      collapsable: false,
      columns,
      isRowSelectable,
      loadOnInit: true,
      method: "post",
      rowClassName: ({ dataRow }) =>
        `b2b-ZadostiOdbaveni--row${dataRow.kolize ? " is-kolize" : ""}`,
      rowDetail: ZadostiRowDetail,
      selectableRows: true,
      showFilterDescription: true,
      sortable: true,
      title: messages.pageHeading(),
      url: DATA.dataZadostiSeznam()
    }
  });

  const grid = gridResultRef.current;
  const selectedId = getSelectedIdsFromGrid(grid);
  const toolbar = useZadostiOdbaveniToolbar({
    reload: grid.result.reload,
    selectedId
  });

  return { grid, toolbar };
}
